var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.9 2.047A1.2 1.2 0 1 1 2.596.352L6.547 4.3 10.498.352A1.19 1.19 0 0 1 11.347 0a1.2 1.2 0 0 1 .848 2.05L8.243 6l3.952 3.95a1.2 1.2 0 1 1-1.696 1.697L6.547 7.694l-3.952 3.953A1.2 1.2 0 1 1 .898 9.95l3.953-3.952L.9 2.048Z",
    fill: "currentColor"
  })));
};

export default SvgClose;